"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFulfillerIdentity = exports.getInvoiceableData = exports.getInvoices = void 0;

var _index = _interopRequireDefault(require("axios/index"));

var _axiosRetry = _interopRequireDefault(require("axios-retry"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(0, _axiosRetry["default"])(_index["default"], {
  retries: 3,
  shouldResetTimeout: true,
  retryDelay: function retryDelay(retryCount) {
    return retryCount * 1000;
  }
});

var getInvoices = function getInvoices(accessToken, identity) {
  var asBuyer = _index["default"].get("https://api.invoices.cimpress.io/v2/invoices/?buyerId=".concat(identity.id, "&buyerType=").concat(identity.type), {
    headers: {
      'Authorization': "Bearer ".concat(accessToken)
    }
  }).then(function (response) {
    return response.data.results;
  });

  var asSeller = _index["default"].get("https://api.invoices.cimpress.io/v2/invoices/?sellerId=".concat(identity.id, "&sellerType=").concat(identity.type), {
    headers: {
      'Authorization': "Bearer ".concat(accessToken)
    }
  }).then(function (response) {
    return response.data.results;
  });

  return Promise.all([asBuyer, asSeller]).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        asBuyerList = _ref2[0],
        asSellerList = _ref2[1];

    var all = asBuyerList.concat(asSellerList) // same as https://gitlab.com/Cimpress-Technology/atsquad/invoicing-services-ct-invoices/InvoiceDataManager/-/blob/master/src/actions/invoicesActions.js#L68
    // TODO: Remove? Awaiting KS's input (as of 2021-11-26)
    .filter(function (invoice) {
      return invoice.status !== 'InvoiceArchived';
    });
    all.sort(function (a, b) {
      return -a.createdAt.localeCompare(b.createdAt);
    });
    return all;
  })["catch"](function (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    throw e;
  });
};

exports.getInvoices = getInvoices;

var getInvoiceableData = function getInvoiceableData(accessToken, identity) {
  var asBuyer = _index["default"].get("https://api.invoices.cimpress.io/v2/invoiceableLines/aggregation?actor=Seller&entityId=".concat(identity.id, "&entityType=").concat(identity.type), {
    headers: {
      'Authorization': "Bearer ".concat(accessToken)
    }
  }).then(function (response) {
    return response.data;
  });

  var asSeller = _index["default"].get("https://api.invoices.cimpress.io/v2/invoiceableLines/aggregation?actor=Buyer&entityId=".concat(identity.id, "&entityType=").concat(identity.type), {
    headers: {
      'Authorization': "Bearer ".concat(accessToken)
    }
  }).then(function (response) {
    return response.data;
  });

  return Promise.all([asBuyer, asSeller]).then(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        asBuyerList = _ref4[0],
        asSellerList = _ref4[1];

    return asBuyerList.concat(asSellerList);
  })["catch"](function (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    throw e;
  });
};

exports.getInvoiceableData = getInvoiceableData;

var getFulfillerIdentity =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(accessToken, fulfillerId) {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _index["default"].get("https://fulfilleridentity.trdlnk.cimpress.io/v1/fulfillers/".concat(fulfillerId), {
              headers: {
                'Authorization': "Bearer ".concat(accessToken)
              }
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            // eslint-disable-next-line no-console
            console.error(_context.t0);
            throw _context.t0;

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function getFulfillerIdentity(_x, _x2) {
    return _ref5.apply(this, arguments);
  };
}();

exports.getFulfillerIdentity = getFulfillerIdentity;